// extracted by mini-css-extract-plugin
export var darkMode = "_5-0";